export const overrides = {
    MuiTypography: {
        root: {
            '&.NeptuneTypography-uppercase': {
                textTransform: 'uppercase'
            },

            '&.NeptuneTypography-breadCrumb-current': {
                fontWeight: 'bold'
            },
            '&.NeptuneTypography-readOnlyInput': {
                padding: '0 0 0 12px',
                fontSize: 16,
                lineHeight: 2.2
            }
        }
    }
};
